import { getAnimalTypes } from "../api/apimethods";

const fetchAnimalTypes = async () => {
    try {
      const response = await getAnimalTypes();
      // Process the response data and create the colours options array
      const animalTypes = response.data;
      return animalTypes;
    } catch (error) {
      console.error("Error fetching animal types:", error);
      return [];
    }
  };
  
  
  export default fetchAnimalTypes;